import React from 'react';
import styles from './HintToast.module.css';

interface HintToastProps {
  text: string;
  emoji?: string;
}

const HintToast: React.FC<HintToastProps> = ({ text, emoji = '🎨' }) => {
  return (
    <div className={styles.toast}>
      <span>{emoji}</span>
      <span>{text}</span>
    </div>
  );
};

export default HintToast;

